module.exports = __webpack_public_path__ + "img/device_fan.38d9c160.png";